import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
    selector: 'lib-time-picker',
    imports: [
        FormsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatTimepickerModule,
        MatInputModule
    ],
    templateUrl: './time-picker.component.html',
    styleUrl: './time-picker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideNativeDateAdapter()],
})
export class TimePickerComponent {
    @Input() form!: FormGroup;

    @Input() key: string = '';
    @Input() value: Date | null = null;
    @Input() label: string = '';
    @Input() className: string = '';
    @Input() placeholder: string = '';
    @Input() readonly: boolean = false;
    @Input() disabled: boolean = false;

    ngOnChanges(simpleChanges: SimpleChanges) {
        const fieldChange: SimpleChange | undefined = simpleChanges['value'];

        if (fieldChange && fieldChange.currentValue !== fieldChange.previousValue && fieldChange.currentValue === null) {
            this.form.get(this.key)?.setValue(null);
        }
    }

    isTimePickerDisabled() {
        return this.readonly || this.form.get(this.key)?.disabled;
    }
}